(function (){
    'use strict';

    angular
        .module('services')
        .service('DeleteClientsService', DeleteClientsService);

    DeleteClientsService.$inject = ['$http', 'API_BASE'];

    function DeleteClientsService ($http, API_BASE) {
        var service = this;

        service.deleteClient = deleteClient;
        service.findByEmail = findByEmail;
        service.deleteByCsv = deleteByCsv;

        function findByEmail(email) {
            return $http.get(API_BASE + `/edufindme/find/email/${email}`);
        }

        function deleteByCsv(data) {
            return $http.post(API_BASE + `/edufindme/delete/csv`, data);
        }

        function deleteClient (user_id, type_user) {
            return $http.get(API_BASE + `/edufindme/delete/${user_id}/${type_user}`);
        }

    }
})();